import { Parametercategory } from '.';
import { RestoreableModel, ResourceFactory } from '../services/';

class Parameter extends RestoreableModel {
  public name:                 string = '';
  public unit:                 string = null;
  public maxvalue:             number;
  public minvalue:             number;
  public recommended_high:     number;
  public recommended_low:      number;
  public decimals:             number;
  public type:                 string;
  public formula:              string;
  public alternative:          string;

  public parametercategories_count: number;
  public parametercategories: Parametercategory[] = [];  
}

const ParameterFactory = ResourceFactory.create<Parameter>(Parameter, 'parameter');

export { Parameter, ParameterFactory };
